import React, { Component } from "react";
import "./Visualization.scss";
export default class Visualization extends Component {
  render() {
    return <div className="Visualization" />;
  }
}
